/**
 * Query-string serializers shared by the API domain modules.
 *
 * FastAPI's query conventions differ from axios defaults in two places —
 * repeated keys for multi-value params and repeated `ids` keys for batch
 * lookups — so the encoders live here, once, and every domain module reuses
 * them to keep the wire format from drifting.
 */

// Batch endpoints take repeated `ids` query keys; one encoder serves every
// batch caller (todos.batch, prds.batch) so the wire format cannot drift.
export function batchIdsQuery(ids: string[]): string {
  const params = new URLSearchParams()
  ids.forEach((id) => params.append('ids', id))
  return params.toString()
}

// FastAPI multi-value query params use repeated keys (`?status=a&status=b`),
// not axios' default bracket-array form.
export const repeatedKeyParamsSerializer = (
  params: Record<string, unknown>
): string => {
  const sp = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null) continue
    if (Array.isArray(value)) {
      for (const v of value) {
        if (v !== undefined && v !== null) sp.append(key, String(v))
      }
    } else {
      sp.append(key, String(value))
    }
  }
  return sp.toString()
}
